import { Link } from "react-router-dom";
import FlowerButton from "@/components/FlowerButton";
import ProductSpotlight from "@/components/ProductSpotlight";
import { BundleTeaser } from "@/components/BundleTeaser";
import { CHARACTERS, findProduct } from "@/data/mellow";

export default function Home() {
  const nouveaute = findProduct("sweet-reminder-lemon");

  return (
    <div>
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 pb-10">
          <div className="max-w-3xl animate-fade-up">
            <p className="font-cursive text-3xl text-[#78353A]/70 mb-2">Bienvenue chez</p>
            <h1 className="font-script text-6xl md:text-7xl lg:text-8xl text-[#78353A] leading-[0.9]">MiniMellow</h1>
            <p className="mt-6 text-lg text-[#4A3B32]/85 leading-relaxed max-w-lg">
              Des carnets tout doux à remplir, des petites histoires et bientôt bien d'autres douceurs — imaginés avec les <span className="font-cursive text-2xl text-[#78353A]">MellowFriends</span>.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-6">
              <Link to="/boutique"><FlowerButton data-testid="hero-cta-shop">Voir la boutique</FlowerButton></Link>
              <Link to="/mellowfriends"><FlowerButton variant="sage" data-testid="hero-cta-friends">Rencontrer la bande</FlowerButton></Link>
            </div>
          </div>
        </div>
      </section>

      {/* Nouveauté spotlight */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-6 pb-16">
        <ProductSpotlight product={nouveaute} eyebrow="Nouveauté" />
        <div className="mt-8"><BundleTeaser product={findProduct("lot-decouverte")} /></div>
      </section>

      {/* Characters */}
      <section className="relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
          <div className="mb-10">
            <p className="font-cursive text-2xl text-[#78353A]/70">Sous cette marque se cachent...</p>
            <h2 className="font-cursive text-5xl md:text-6xl text-[#78353A] leading-none">Les MellowFriends</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CHARACTERS.map((c) => (
              <Link
                key={c.slug}
                to={`/personnages/${c.slug}`}
                className="group relative rounded-3xl border-2 border-dashed border-[#D1D5CB] p-6 hover:-translate-y-1 transition-transform"
                style={{ background: c.bg }}
                data-testid={`character-card-${c.slug}`}
              >
                <div className="relative aspect-square rounded-2xl overflow-hidden bg-[#FAF9F6]/60 mb-4">
                  {c.portrait ? (
                    <img src={c.portrait} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <span className="daisy-deco" style={{ width: 90, height: 90 }}></span>
                    </div>
                  )}
                </div>
                <h3 className="font-cursive text-4xl text-[#78353A] leading-none">{c.name} <span className="text-2xl text-[#4A3B32]/70">{c.species}</span></h3>
                <p className="mt-2 text-sm text-[#4A3B32]/80">{c.tagline}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Story teaser */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="rounded-[2.5rem] p-10 md:p-14 bg-[#EAECE1] border-2 border-dashed border-[#D1D5CB] relative overflow-hidden">
          <span className="daisy-deco absolute top-6 right-8"></span>
          <div className="max-w-3xl">
            <div>
              <p className="font-cursive text-2xl text-[#78353A]/70">Notre histoire</p>
              <h2 className="font-cursive text-5xl md:text-6xl text-[#78353A] leading-none">Une bande, six personnalités</h2>
              <p className="mt-4 text-[#4A3B32]/85 leading-relaxed max-w-xl">
                Chaque MellowFriend porte son univers, ses passions, sa maison à MellowCity. Nos carnets sont pensés autour d'eux : des pages à remplir, des petites histoires et des illustrations toutes douces pour rêver, écrire et partir en aventure.
              </p>
              <div className="mt-6">
                <Link to="/histoire"><FlowerButton variant="pink" data-testid="story-cta">Lire l'histoire</FlowerButton></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
